import { queryClient } from '@/lib/react-query'
import { authSessionBootstrapKeys } from '@/hooks/queries/useAuthSessionBootstrap'
import { useAuthStore } from '@/store/useAuthStore'
import { markPerformance, measurePerformance } from '@/utils/dev/performanceMarks'

/**
 * Bootstrap session — marqueurs perf + helpers post-login / logout.
 * Le fetch lui-même vit dans useAuthSessionBootstrap (React Query).
 */

let bootstrapStarted = false
let bootstrapPerfEnded = false

export function markSessionBootstrapPerfStart(): void {
  if (bootstrapStarted) {
    return
  }
  bootstrapStarted = true
  markPerformance('bootstrap-start')
}

export function markSessionBootstrapPerfEnd(): void {
  if (bootstrapPerfEnded) {
    return
  }
  bootstrapPerfEnded = true
  markPerformance('bootstrap-done')
  measurePerformance('bootstrap-total', 'bootstrap-start', 'bootstrap-done')
}

export function resetSessionBootstrap(): void {
  bootstrapStarted = false
  bootstrapPerfEnded = false
  queryClient.removeQueries({ queryKey: authSessionBootstrapKeys.all })
  useAuthStore.setState({ sessionBootstrapped: false, sessionHydrated: false })
}

/** Après login email / OAuth — session déjà hydratée, pas de refetch bootstrap. */
export function markSessionBootstrapComplete(): void {
  bootstrapStarted = true
  markPerformance('bootstrap-start')
  markPerformance('persist-hydrated')
  markPerformance('session-fetch-start')
  markPerformance('session-fetch-end')
  useAuthStore.setState({ sessionBootstrapped: true })
  markSessionBootstrapPerfEnd()
}
